/**
 * Feature flags (CRA: set REACT_APP_* then rebuild).
 * Community chat is off until re-enabled explicitly.
 */
export const COMMUNITY_CHAT_ENABLED =
  process.env.REACT_APP_ENABLE_COMMUNITY_CHAT === 'true';

/**
 * Quant AGI is stopped (Drew decision, Oct 2026). Off unless REACT_APP_FEATURE_QUANT_AGI=true at build time.
 * Off: no nav item, no dashboard suggestions panel, /quant-agi and subroutes redirect to /dashboard.
 * Backend counterpart: FEATURE_QUANT_AGI=true (backend/utils/featureFlags.js).
 */
export const QUANT_AGI_ENABLED =
  process.env.REACT_APP_FEATURE_QUANT_AGI === 'true';
